import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

if ("serviceWorker" in navigator) {
    if (process.env.NODE_ENV === "production") {
        window.addEventListener("load", () => {
            navigator.serviceWorker.register("/service-worker.js").catch(error => {
                console.error("Impossible d'activer le mode hors connexion", error);
            });
        });
    } else {
        // Un ancien build de production peut encore contrôler localhost et
        // servir un bundle obsolète après un changement de branche.
        navigator.serviceWorker.getRegistrations()
            .then(registrations => Promise.all(registrations.map(registration => registration.unregister())))
            .catch(error => console.warn("Impossible de désactiver le cache hors connexion", error));

        if ("caches" in window) {
            caches.keys()
                .then(keys => Promise.all(
                    keys
                        .filter(key => key.startsWith("suivi-qualite-app-"))
                        .map(key => caches.delete(key))
                ))
                .catch(error => console.warn("Impossible de nettoyer le cache de développement", error));
        }
    }
}
